import { render, staticRenderFns } from "./OfferRequestCustomerView.vue?vue&type=template&id=b7a3fb96&"
import script from "./OfferRequestCustomerView.vue?vue&type=script&lang=js&"
export * from "./OfferRequestCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./OfferRequestCustomerView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports